var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.107 -42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z",
    transform: "translate(46.107 42)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.846 -36.807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.683,86.6l3.783-3.513a1.569,1.569,0,0,0-.919-.292H72.819a1.569,1.569,0,0,0-.919.292Z",
    transform: "translate(-8.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9,94.258l2.522,2.344a1.619,1.619,0,0,0,.3-.933V92.833a1.619,1.619,0,0,0-.3-.933Z",
    transform: "translate(-79.315 -8.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.322,94.444,62.8,92.1a1.619,1.619,0,0,0-.3.933v2.836a1.619,1.619,0,0,0,.3.933Z",
    transform: "translate(0 -8.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.93,130l-1.247,1.161L74.437,130,71.9,132.358a1.569,1.569,0,0,0,.919.292H78.54a1.569,1.569,0,0,0,.919-.292Z",
    transform: "translate(-8.73 -43.837)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.24aa8ef52c9012c1910d06495113a088.svg";
export { ForwardRef as ReactComponent };